import React, {useContext, useEffect, useState} from "react"
import {injectIntl} from "react-intl";
import LogstreamTabHeader from "../commonui/LogstreamTabHeader";
import Column from "@amzn/meridian/column";
import LogstreamTabBody from "../commonui/LogstreamTabBody";
import {
    getAutomationMQTTTopic, getFormattedTimestamp,
    getMQTTClientConfig,
} from "../util/Util";
import {LogStoreContext} from "../store/context/LogStoreContext";
import {getLocalizedMessage} from "../util/Localization";
import Alert from "@amzn/meridian/alert";
import {EVENT_TYPE} from "../util/Constants";

const CommonDeviceLogstream = (props) => {

    const {addLog} = useContext(LogStoreContext);
    const [isSubscribing, setIsSubscribing] = useState(false)
    const [error, setError] = useState(false)
    const {protocols, dispatch, deviceList, deviceType, intl} = props;


    const onMessage = (message) => {
        const parsedData = JSON.parse(message.toString())
        if (protocols.includes(parsedData.component)) {
            parsedData.timestamp = getFormattedTimestamp(parsedData.timestamp)
            addLog(parsedData)
        }
    }

    const headerProps = {
        isSubscribing,
        setIsSubscribing,
        topic: getAutomationMQTTTopic(),
        config: getMQTTClientConfig(),
        setError,
        intl,
        onMessage,
        deviceType,
        deviceList,
        eventType: EVENT_TYPE.MHE_LOG_DATA
    }

    const loadDeviceList = () => {
        if (deviceList.length === 0) {
            dispatch({type: 'LOAD_VIEW', data: {dispatcher: dispatch}});
        }
    }

    useEffect(() => {
        loadDeviceList()
    }, []);

    return (
        <Column>
            <LogstreamTabHeader {...headerProps}/>
            {error && <Alert type="error">{getLocalizedMessage({intl, stringId: 'log.error'})}</Alert>}
            <LogstreamTabBody {...headerProps}/>
        </Column>
    );
}

export default injectIntl(CommonDeviceLogstream)


// WEBPACK FOOTER //
// ./src/components/commonui/CommonDeviceLogstream.js